/*global $:false */

import tmpl from "../templates/recordm-importer-stats-details.dot";
import tmpl_filter_links from "../templates/recordm-importer-stats-details-filter-links.dot";

const ImporterStatsDetailsV = function(core, statM, callbacks) {
    const $mainContainer = $(tmpl({data: statM, locale: core.getLocale()})),
        $refreshBtn = $(".js-refresh", $mainContainer),
        $refreshBtnMsg = $(".js-refresh-msg", $refreshBtn),
        $endDate = $(".js-end-date", $mainContainer),
        $duration = $(".js-duration", $mainContainer),
        $total = $(".js-total", $mainContainer),
        $successes = $(".js-successes", $mainContainer),
        $errors = $(".js-errors", $mainContainer),
        $discarded = $(".js-discarded", $mainContainer),
        defaultRefreshBtnMsg = core.translateString("recordm-importer.stats", "action.start-refresh"),
        stopRefreshingMsg = core.translateString("recordm-importer.stats", "action.stop-refresh");

    let isRefreshing = false;

    const resetRefreshInProgressMsg = function() {
        $refreshBtn.removeClass("btn-success");
        $refreshBtnMsg.text(defaultRefreshBtnMsg);
    };

    const showRefreshInProgressMsg = function() {
        $refreshBtn.addClass("btn-success");
        $refreshBtnMsg.text(stopRefreshingMsg);
    };

    const onRefreshBtnClick = function() {
        if(isRefreshing){
            isRefreshing = false;
            callbacks.stopRefresh();
        } else {
            isRefreshing = true;
            showRefreshInProgressMsg();
            callbacks.refresh();
        }
    };

    const onBackBtnClick = function(){
        core.navigateBack();
    }

    const _addBtnListeners = function() {
        $mainContainer.on("click", ".js-back", onBackBtnClick);
        $mainContainer.on("click", ".js-refresh", onRefreshBtnClick);
    };

    const _removeBtnListeners = function() {
        $mainContainer.off("click", ".js-back", onBackBtnClick);
        $mainContainer.off("click", ".js-refresh", onRefreshBtnClick);
    };

    const blink = function($element) {
        $element.addClass("flash");

        $element.fadeOut(1000)
            .fadeIn(1000, function() {
                $element.removeClass("flash");
            });
    };

    return {
        start: function() {
            _addBtnListeners();

            $mainContainer.appendTo('#'+core.getAppInstanceId());

            core.translate('recordm-importer.stats', $mainContainer);

        },
        resume: function(){
            _addBtnListeners();
            $mainContainer.appendTo('#'+core.getAppInstanceId());
        },
        pause: function(){
            this.stopRefresh();
            _removeBtnListeners();
            $mainContainer.detach();
        },
        stop: function(){
            this.stopRefresh();
            _removeBtnListeners();
            $mainContainer.remove();
        },
        addFilterBtns: function(){
            const $searchFiltersContainer = $(".search-filters-container", $mainContainer);

            //React to click events on the filters
            $searchFiltersContainer.on("click", ".js-stat-filter-link", function(e) {
                e.stopPropagation();
                e.preventDefault();

                const filter = $(e.target).attr("data-filter");

                callbacks.setSearchFilter(filter);
            });

            //Show quick filters below the search input
            $searchFiltersContainer.append($(tmpl_filter_links())).removeClass("hidden");

            core.translate('recordm-importer.stats', $mainContainer);
        },
        refresh: function(){
            const total = statM.getTotal();
            const successes = statM.getNumSuccesses();
            const errors = statM.getNumErrors();
            const discarded = statM.getNumDiscarded();

            if(statM.isDone()){
                $endDate.text(statM.getFormattedEndDate(core.getLocale()));
                $duration.text(statM.getDuration());
            }

            if(total != $total.text()){
                $total.text(total);
                blink($total);
            }

            if(successes != $successes.text()){
                $successes.text(successes);
                blink($successes);
            }

            if(errors != $errors.text()){
                $errors.text(errors);
                blink($errors);
            }

            if(discarded != $discarded.text()){
                $discarded.text(discarded);
                blink($discarded);
            }
        },
        stopRefresh: function() {
            isRefreshing = false;

            //Refresh one last time to ensure it shows the last results
            this.refresh();

            resetRefreshInProgressMsg();

            if(statM.isDone()){
                $refreshBtn.remove();
            }
        },
        getSearchContainer: function() {
            return $(".js-search-container", $mainContainer);
        },
        getResultsContainer: function() {
            return $(".js-results-container", $mainContainer);
        }
    };
};

export default ImporterStatsDetailsV;
